module.exports = __webpack_public_path__ + "static/img/アセット 17@2x.a731f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 17@2x.png
// module id = CNbj
// module chunks = 1